<template>
  <div>
    <!-- <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="800px"
 
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    > -->
    <div id="content">
    <section class="wrapper">
      
      <div class="mig_header">
          <img src="https://mig-bucket.s3.ap-south-1.amazonaws.com/mig_header.png">
      </div>
      <div class="container">
        <div class="columns">
          <div class="column salutation">
            <p>श्रीमान् अध्यक्ष ज्यू, <br>
                मिग होल्डिङ्गस् लिमिटेड ।	<br>
                </p>
          </div>
          <div class="column subject">
            <b>विषयः शेयर खरिद सम्बन्धमा ।</b>
          </div>
          <div class="column profile-photo">
            <img :src="citizen.item.photo_scan">
          </div>
        </div>
        <div class="content">
          <div class="salutation">
            <p style="margin-bottom:-10px;">महोदय,</p>
            <p><span style="margin-left:2.5em">मिग होल्डिङ्गस् लिमिटेडको प्रबन्ध–पत्र तथा नियमावली अनुसार कम्पनीको शेयर खरिद गरी शेयर धनी बन्न</span>इच्छुक भएकोले उल्लेखित विवरण अनुसारको शेयर खरिदको लागि निम्न बमोजिम रकम यसै निवेदनका साथ पेश गरेको छु ।</p>
          </div>
          <div class="table-content">
            <h2>खरिद गर्न चाहेको शेयर विवरण</h2>
            <table class="table is-bordered">
              <thead>
                <tr>
                  <th style="text-align:center;">शेयर कित्ता</th>
                  <th style="text-align:center;">प्रति शेयर मूल्य</th>
                  <th style="text-align:center;">जम्मा शेयर मूल्य</th>
                  <th style="text-align:center;">कैफियत</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style="text-align:center;">२५०/–</th>
                  <th style="text-align:center;">१००/–</th>
                  <th style="text-align:center;">२५,०००/–</th>
                  <th style="text-align:center;"></th>
                </tr>
              </tbody>
            </table>
          </div>
          <p>अक्षेरुपी : पच्चिस हजार रुपैयाँ मात्र ।</p>
          <p></p>
          <div class="personal-details">
          <div class="columns mid-column">
            <div class="column">
              <h2>निवेदकको विवरण</h2>

              <p style="margin-top:-10px;">नाम : <b>{{citizen.item.full_name}}</b></p>
              <p>Name in English :<b>  {{citizen.item.english_name}}        </b></p>
              <p>स्थायी ठेगाना:	<b>  {{citizen.item.permanent_address}} </b></p>
              <p>हालको ठेगाना: <b>  {{citizen.item.current_address}}   </b></p>
              <p>अस्थाई ठेगाना: <b>  {{citizen.item.temporary_address}} </b></p>
              <p>बुबा/आमा/पतिको नाम:<b>{{citizen.item.father_name}}          </b></p>
              <p>बाजे/ससुराको नाम: <b>{{citizen.item.grandfather_name}}    </b></p>
              <p>बैक नाम:    <b>  {{citizen.item.bank}}         </b></p>
              <p>हकवालाको नाम: <b>{{citizen.item.beneficiary_name}}    </b></p>
              <p>हकवालाको सम्पर्क नं.:  <b>  {{this.changeToNepali(citizen.item.beneficiary_contact)}}</b></p>
              <p>परिचयकर्ता:  <b>    {{citizen.item.referred_by}}     </b></p>
            </div>
            <!-- <div class="column">
            </div> -->
            <div class="column" style="margin-top:35px;">
              <p>जन्म मिति: <b>{{this.changeToNepali(citizen.item.birth_date)}}   </b></p>
              <br/>
              <p>नागरिता नं.: <b>{{citizen.item.citizenship_number}}        </b> </p>
              <p>जारी मिति : <b>{{this.changeToNepali(citizen.item.citizenship_date)}}               </b> </p>
              <p>मोबाईल नं.: <b>{{this.changeToNepali(citizen.item.mobile_number)}}             </b> </p>
              <p>इमेल:     <b>{{citizen.item.email}}                     </b> </p>
              <br/>
              <!-- <p>बैक नाम:   <b>{{citizen.item.bank}}                      </b> </p> -->
              <p>खाता नं. :  <b>{{citizen.item.account_number}}            </b>  </p>
              <p>नाता:      <b>{{citizen.item.relationship}}              </b> </p>
              <p>ठेगाना:     <b>{{citizen.item.beneficiary_address}}               </b> </p>
              <p>दर्ता मिति : <b>{{this.changeToNepali(citizen.item.registration_date)}}               </b> </p>
            </div>
          </div>
          </div>
          <div class="columns">
            <div style="text-align:center; margin-top: -10px;" class="column finger-print">
              <p style="text-align:center; margin-bottom:10px;">निबेदकको औंठा छाप</p>
              <div class="columns">
                <table class="table is-bordered fingerprint" style="margin:auto; height:100px;">
                  <thead>
                    <tr>
                      <th style="text-align:center;">बाँया</th>
                      <th style="text-align:center;">दायाँ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="fingerprint-img"><img style="float:left;" :src="citizen.item.fingerprint_left"></th>
                      <th class="fingerprint-img"><img :src="citizen.item.fingerprint_right"></th>
                    </tr>
                  </tbody>
                </table>
                
              <!-- <div class="column fingerprint1">
                <p style="text-align:center; margin-bottom:0px; float:right">बाँया</p>
                <img :src="citizen.item.fingerprint_left">
              </div>
              <div class="column fingerprint2">
                  <p style="text-align:center; margin-bottom:0px; float:left">दायाँ</p>
                <img :src="citizen.item.fingerprint_right">
              </div> -->
              </div>
              <div class="signature-photo">
                  <img :src="citizen.item.signature_scan">
                </div>
              <div  style="margin-top:-3mm;">-------------------------</div>
                <div>निबेदकको दस्तखत</div>
            </div>
            <div class="column mid-col-1">
            <!-- <div class="sig1">
              <p>-------------------------</p>
                <p>निबेदकको दस्तखत</p>
          </div> -->
          <div style="width:75px;height:35px;display:inline-block;">कोड नं. :- </div>
                <div style="width:50px;height:35px;border:1px solid #000;background-color:white;display:inline-block;text-align:center;">{{citizen.item.code_no}}</div>
            </div>
            <div class="column official end-col-1">
              <div style="width:100px;height:10px;;display:block;"></div>
             <div class="test">
                <p>-------------------------</p>
                <p>प्रमाणित गर्ने:</p>
                <p>नाम: सुमन थापा</p>
                <p>पद: अध्यक्ष</p>
                <p>मिती: {{this.changeToNepali(citizen.item.form_date_one)}}</p>     
                <p>रसिद मिती :<span class="details">{{this.changeToNepali(citizen.item.receipt_date)}} </span></p>
             </div>
                <div class="test">
               <!-- <div style="width:100px;height:100px;;display:block;"></div> -->
                <!-- <p> -->
                <!-- <div style="width:75px;height:35px;;display:inline-block;">कोड नं. :- </div>
                <div style="width:50px;height:35px;border:1px solid #000;background-color:white;display:inline-block;text-align:center;">{{citizen.item.code_no|'N/A'}}</div> -->
                <div style="width:120px;height:35px;;display:inline-block;margin-left:25px;">अफिस कोड नं. :- </div>
                <div style="width:50px;height:35px;border:1px solid #000;background-color:white;display:inline-block;text-align:center;">{{citizen.item.office_code_no}}</div>
            </div>
            </div>
          </div>
          <!-- <div class="columns">
            <div class="column">
               <!col00-- <div style="width:100px;height:20px;;display:block;"></div> --col99>
               <div class="signature-photo">
                  <img :src="citizen.item.signature_scan">
                </div>
              <div>-------------------------</div>
                <div>निबेदकको दस्तखत</div>
            </div>
             <div class="column"  style="flex: 0 0 60%;">
               <div style="width:100px;height:20px;;display:block;"></div>
                <p>
                <div style="width:75px;height:35px;;display:inline-block;">कोड नं. :- </div>
                <div style="width:50px;height:35px;border:1px solid #000;background-color:white;display:inline-block;text-align:center;">{{citizen.item.code_no|'N/A'}}</div>
                <div style="width:120px;height:35px;;display:inline-block;margin-left:25px;">अफिस कोड नं. :- </div>
                <div style="width:50px;height:35px;border:1px solid #000;background-color:white;display:inline-block;text-align:center;">{{citizen.item.office_code_no|'N/A'}}</div>
            </div>
            </div> -->
        </div>
        
        <!-- {{citizen.item.first_name}} -->
      </div>
        <!-- <button class="button is-black print_button" id="printPageButton" onclick="window.print();"> Print </button> -->

       <div style="margin-top:10px;" class="mig_footer">
          <img src="https://mig-bucket.s3.ap-south-1.amazonaws.com/mig_footer.png">
      </div>
    </section>
          </div>
                <!-- <button class="button is-black print_button" id="printPageButton" onclick="window.print();"> Print </button> -->

          <!-- <div id="editor"></div> -->
      <!-- <button id="cmd">generate PDF</button> -->

      <!-- <button class="btn btn-danger" @click="printFacture">generate PDF</button> -->

     <!-- </vue-html2pdf> -->
     <div class="jagada">
       <div class="container">
         <div class="columns">
           <div class="column">
            <p> श्री संचालक समिति <br>
             मिग होल्डीब्स लि. <br>
             ललितपुर म.न.पा.–</p>
           </div>
           <div class="column" style="text-align:center;">
             मिति : {{this.changeToNepali(citizen.item.form_date)}}
           </div>
         </div>
         <div class="main-content">
           <div class="subject">
           <p>विषयः जगेडा शेयर खरिद गर्ने सम्वन्धमा ।</p>
           </div>
           <div class="body-content">

             <p><span style="margin-left:2.5em"> उपरोक्त सम्वन्धमा यस कम्पनीले जगेडा शेयर विक्रीको लागि मिति <span v-if="citizen.item.form_date">{{this.changeToNepali(citizen.item.form_date)}} </span><span v-else style="margin-right:100px;">         </span> मा आब्हान </span> गरेकोमा मलाई पनि त्यस कम्पनीको जगेडा शेयर २५०० थान  खरिद गर्ने इच्छा भएकोले कम्पनीको संचालक समिति समक्ष जगेडा शेयर खरिद गर्न यो निवेदन गरेको छु । </p>
         </div>
       </div>
       <div class="holder-details">
         <div class="columns">
           <div class="column">
           </div>
           <div class="column">
           </div>
           <div class="column">
            <p>निवेदक</p> <br>
          
          <p>   नाम : <span class="details">{{citizen.item.full_name}}</span><p><br>
          <p>  ठेगाना :<span class="details">{{citizen.item.permanent_address}} </span></p><br>
          <p> दस्तखत : <span class="details"></span><p>
          <div class="signature-photo">
                  <img :src="citizen.item.signature_scan">
                </div>
           </div>
         </div>
       </div>
     </div>
      <button class="button is-black print_button" id="printPageButton" onclick="window.print();"> Print </button>

  </div>
  </div>
</template>

<script>
// import VueHtml2pdf from 'vue-html2pdf';
import html2canvas from 'html2canvas';
import $ from "jquery";
// import moment from 'moment';
import { jsPDF } from "jspdf";
import { mapActions, mapState } from "vuex";
import nepalify from 'nepalify';
export default {
  // components: {
  //   VueHtml2pdf
  // },
  name: 'user_details',
   props: {
        // citizen: {
        //     required: true,
        //     type: Object
        // }
    },
    mounted() {
      this.$store.commit('isNavBarVisible', false);
    },
  // data() {
  //   return {
  //     citizen: this.$store.getters['citizens/citizen'](this.$route.params.id)
  //   }
  // }
  computed: {
    ...mapState({
      citizen: state => state.citizens.item
    })
  },
  created() {
    const citizenId = this.$route.params.id
    this.fetchCitizenById(citizenId)
  },
  methods: {
    ...mapActions('citizens', ['fetchCitizenById']),
    // generateReport() {
    //   this.$refs.html2Pdf.generatePdf()
    // }
    // generatePdf(){
    //   const doc = new jsPDF('p', 'pt', 'A4');
    //   doc.html(DATA.innerHTML, {
    //   'x': 15,
    //   'y': 15,
    //   'width': 200,
    //   'elementHandlers': handleElement
    //   });

    //   doc.save('test.pdf');
    // },
    printFacture() {
    var pdf = new jsPDF('A4');
    var element = document.getElementById('facture');
    var width= element.style.width;
    // console.log(width)
    var height = element.style.height;
    // document.getElementById("facture").style.overflow = 'hidden';
    html2canvas(element, {scrollY: -window.scrollY}).then(function(canvas) {
            var img = canvas.toDataURL();
            pdf.addImage(img, 'JPEG', 15, 40, width, height);
            pdf.save('facture' + '.pdf')
            // pdf.save('facture' + '.pdf')
            // window.open(img);
        });
    // html2canvas(element).then(canvas => {
    //     var image = canvas.toDataURL('image/png');
    //     pdf.addImage(image, 'JPEG', 15, 40, width, height);
    //     pdf.save('facture' + '.pdf')
    // });
},
changeToNepali(value){
  return nepalify.format(value);
}
  }
};

var doc = new jsPDF();
var specialElementHandlers = {
    '#editor': function (element, renderer) {
        return true;
    }
};

$('#cmd').click(function () {
    doc.fromHTML($('#content').html(), 15, 15, {
        'width': 170,
            'elementHandlers': specialElementHandlers
    });
    doc.save('sample-file.pdf');
});
</script>

<style lang="scss">
.mig_header img{
  height: 80px;
  width: 100%;
}
.wrapper{
  margin-top: -52px;
}
.container{
  width: 90%;
  margin: auto;
}
.salutation p{
  font-size: 0.9em;
}
p{
  color: black;
}
.container p{
  padding: 3px;
}
.subject{
  margin-top: 15px;
  text-align: center;
}
.profile-photo img{
  // min-width:25mm; 
  // max-width: 25mm;
  max-height: 25mm;
  max-height: 25mm;
  float: right;
  margin-bottom: 10px;
}
.fingerprint-img img{
  max-height: 30mm;
  min-height: 30mm;
}
.signature-photo img{
  // max-width: 30mm;
  max-height: 20mm;
  // min-width: 30mm;
  min-height:20mm;
  // float: left;
  // margin-bottom: 10px;
  display: inline-block;
}
.table-content{
  margin-top: 0px;
  margin-bottom: 0px;
}
.table-content h2{
font-size: 0.9em;
}
.table{
  font-size: 0.9em;
}
.personal-details{
  margin-top: -30px;
}
.personal-details p{
  margin-top: -20px;
  font-size: 0.9em;
}
.personal-details h2{
  font-size: 1em;
}
// table thead tr th{
//   text-align: center;
// }
.content{
  margin-top: -50px;
}
// table{
//   margin-top: 5px;
//   width: 20%;
// }
.official p{
  margin-top: -20px;
}
.print_button{
  float: right;
  margin-right: 50px;
  margin-bottom: 30px;
}
.sig p{
  margin-top: -20px;
}
.jagada{
  margin-top: 200px;
}
.details{
  margin-left: 10px;
}
.body-content{
  margin-top: 50px;
}
.holder-details{
  margin-top: 50px;
}
.mid-column{
  display: flex;
}
.mid-col-1{
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.end-col-1{
  display: flex;
    flex-direction: column;
    justify-content: space-between;
}
// .holder-details{
//   text-align: right;
//   margin-right: 250px;
// }

@media print {
     @page {
     margin-top: 0.3in;
    margin-bottom: 0.25in;
    margin-left: 0.4in;
    margin-right: 0.3in;
}
  #printPageButton {
    display: none;
  }
  .noprint {
      visibility: hidden;
   }
}
</style>